// Components
import {NewApplicationStep2Feature} from "../../features/newApplicationStep2";

const NewApplicationStep2Page = () => <NewApplicationStep2Feature />
export default NewApplicationStep2Page;
